// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b6d39ade] .ant-checkbox-wrapper {\n  margin-top: 10px;\n}\n[data-v-b6d39ade] .ant-modal-body {\n  min-height: 300px;\n}", ""]);
// Exports
module.exports = exports;
